module.exports = __webpack_public_path__ + "img/qualityBlue.87ccd205.png";